import { observer } from 'mobx-react-lite';
import React, { useEffect, useRef, useState } from 'react';
import AppState from '../../../js/AppState';

import SpeechHelper from '../../../js/SpeechHelper';
import PresentationHelper from '../../../js/PresentationHelper';

import './CanvasCharacters.css'

let onloadend = null

const CanvasCharacter = ({ char, currentNode, callBack }) => {

  let ref = useRef(null)

  useEffect(() => {
    
    setTimeout(() => {
      callBack(char, ref.current)
    }, 1000)

    return () => {

    }
  }, [])


  let hide = false

  if(currentNode) hide = !currentNode.isCharacterDisplayed(char)

  return(
    <div className={ "CanvasCharacter " + char + (hide? " hidden" : "") }  key={"char_" + char}> 
      <canvas id={"canvas_char_" + char} ref={ ref }/> 
    </div>
  )
}

const CanvasCharacters = ({ onClick }) => {
  
  function handleClick(e) {
    e.stopPropagation()
    callClick()
  }
 
  function callClick() {
    if(onClick) onClick()
  }

  function canvasRendered(id, canvas) {
    SpeechHelper.initCharacterFromCanvas(id, canvas)
  }


  return (
    <div className={"CanvasCharacters"} >
      { SpeechHelper.currentIds && SpeechHelper.currentIds.map((char, i) =>  <CanvasCharacter key={"char_container_" + char} onClick={(e) => handleClick(e)} char={char} currentNode={ PresentationHelper.currentNode } callBack={canvasRendered}/> ) }
    </div>
  );
};

export default observer(CanvasCharacters);
